import moment from "moment";
import { ValueStrings } from "./constantsString";
import { getItemSession } from "../utils/session";
import { API_URLS } from "../network/appUrls";
import { REFERENCE_CONDITION_CONVERSION_UNITS } from "../constants/global.constants";

let currentPlantId;
const { CIP_DATE_TIME_FORMAT } = ValueStrings;

export const updatePlantId = (plantId) => {
  if (plantId !== undefined) currentPlantId = plantId;
};

export const extractPlantId = () => {
  if (currentPlantId) {
    return currentPlantId;
  } else {
    var lastVisitedURL = getItemSession("lastVisitedURL");
    if (lastVisitedURL) {
      var searchParams = new URLSearchParams(lastVisitedURL.split("?")[1]);
      const plantId = searchParams.get("plantId");
      updatePlantId(plantId);
      return plantId;
    }
  }
};

export const getDuplicateItems = (array) => {
  const seen = new Set();
  const duplicates = [];

  for (const item of array) {
    const itemString = JSON.stringify(item);

    if (
      seen.has(itemString) &&
      !duplicates.some((dup) => JSON.stringify(dup) === itemString)
    ) {
      duplicates.push(item);
    } else {
      seen.add(itemString);
    }
  }
  duplicates.sort((a, b) => {
    if (!a && !b) {
      return 0;
    } else if (!a) {
      return 1;
    } else if (!b) {
      return -1;
    } else {
      return new Date(a) - new Date(b);
    }
  });
  return duplicates;
};

export const getCurrencySymbol = {
  USD: "$",
  Yuan: "元",
  Euro: "€",
};

export const getControlId = (text = "dupont", cntrlType) => {
  const label = text
    .toLowerCase()
    .replace(/\s/g, "_", "_")
    .replace(/[^a-z0-9_]/g, "");
  return cntrlType ? `${label}_${cntrlType}` : label;
};

export const getChangedData = (updatedData, initialData) => {
  if (Array.isArray(updatedData) || updatedData === "") {
    return updatedData;
  }
  const dataDiff = {};
  for (const key in updatedData) {
    if (initialData) {
      if (initialData[key] !== null && typeof initialData[key] === "object") {
        dataDiff[key] = getChangedData(updatedData[key], initialData[key]);
        if (typeof dataDiff[key] === "object") {
          //need this remove && condition, BE to implement empty attribute
          if (Object.keys(dataDiff[key]).length === 0 && key !== "Attributes") {
            delete dataDiff[key];
          }
        }
      } else if (initialData[key] !== updatedData[key]) {
        dataDiff[key] = updatedData[key];
      }
    }
  }
  return dataDiff;
};

export const UpdateSetWithKey = (prevData, key, value) => {
  const updatedData = { ...prevData };
  updatedData[key] = value;
  return updatedData;
};

export const getFormattedDate = (dateString) => {
  const date = moment(dateString).isValid();
  return date ? moment(dateString).format(ValueStrings.dateFormat) : "";
};

export const getSelectedPlantTrainInfo = (plantData, plantId) => {
  const plantInfo = plantData.find((plant) => plant.plant_id === plantId);
  return plantInfo?.sel_train ?? 1;
};

export const getIndex = (params, column) => {
  return column ? params.node.rowIndex + 1 : "";
};

// get date with start of the day if time not given
export const initializeDate = (dateString) => {
  if (!dateString) return null;
  let date = moment(dateString);
  return date.isValid() ? date.toDate() : null;
};

export const formatDate = (dateString, dateFormat = CIP_DATE_TIME_FORMAT) => {
  const date = moment(dateString);
  return date.isValid() ? date.format(dateFormat) : "";
};

// Common function to convert moment date to Date object
export const convertMomentToDate = (dateValue) => {
  return moment(dateValue).toDate();
};

// navigate to add new plant page
export const navigateToCreateNewPlant = (navigate) => {
  const basePath = API_URLS.basePath;
  navigate(`${basePath}`, { state: { openAddPlant: true } });
};

// unit coversion for reference condition max limit based on unit settings
export const ReferenceUnitConverter = (value, unit) => {
  if (value === null || value === undefined || !unit) {
    return value;
  }

  const { FLOW, PRESSURE, TEMPERATURE, CONDUCTIVITY } =
    REFERENCE_CONDITION_CONVERSION_UNITS;
  let convertedValue;

  // Check flow conversions
  if (FLOW[unit]) {
    convertedValue = value * FLOW[unit];
  }
  // Check pressure conversions
  else if (PRESSURE[unit]) {
    convertedValue = value * PRESSURE[unit];
  }
  // Check temperature conversions
  else if (TEMPERATURE[unit]) {
    const { multiplier, offset } = TEMPERATURE[unit];
    convertedValue = value * multiplier + offset;
  }
  // Check conductivity conversions
  else if (CONDUCTIVITY[unit]) {
    convertedValue = value * CONDUCTIVITY[unit];
  }
  // No conversion if unit not recognized
  else {
    convertedValue = value;
  }

  return parseFloat(convertedValue.toFixed(2));
};
